import React, {useCallback, useEffect, useState} from 'react';
import {TestDrag} from "./test-grag/Test-drag";
import {TestAudio} from "./test-audio/Test-audio";
import {TestImage} from "./test-image/Test-image";
import {StatusTest} from "./status-test/StatusTest";
import {useAppDispatch, useAppSelector} from "common/hook";
import {NavLink, useNavigate, useParams} from "react-router-dom";
import {ROLE_DEMO_STUDENT, ROLE_STUDENT} from "entities/constants/constants";
import {Preloader} from "components/layout/preloader/Preloader";
import {NothingYetMessage} from "components/pages/personal-cabinet/nothing-yet-message/NothingYetMessage";
import {postStudentAnswer} from "features/model/service/test/student-answer/postStudentAnswer";
import {testViewAnswerId} from "features/model/service/test/test-view-answer-id/testViewAnswerId";
import {resetCorrectTestCount} from "features/model/slice/test/correct-test/correctTestSlice";
import {resetTestViewAnswerId} from "features/model/slice/test/test-view-answer-id/testViewAnswerIdSlice";


interface Answer {
    questionId: number;
    answerId: number;
}

interface DragData {
    questionId: number;
    answerDrag: { id: number; position: number; text: string }[];
}

export const TestTable = () => {
    const dispatch = useAppDispatch()
    const roleType = useAppSelector((state) => state.role.roleType);
    const testData = useAppSelector(state => state.getTests)
    const {model, isLoading} = testData
    const userId = useAppSelector((state) => state.profile.data?.id);


    const [dragData, setDragData] = useState<{ [testId: number]: { id: number; position: number; text: string }[] }>({});


    const navigate = useNavigate();

    const {testId} = useParams()

    const isStatusTestVisible = roleType !== null && roleType !== undefined && roleType !== ROLE_STUDENT && roleType !== ROLE_DEMO_STUDENT;

    const [selectedAnswers, setSelectedAnswers] = useState<{ [key: number]: number }>({});


    const handleDragChange = (data: { questionId: number; answerDrag: { id: number; position: number; text: string }[] }) => {
        const {questionId, answerDrag} = data;

        setDragData(prevDragData => {
            const newDragData = {...prevDragData};
            newDragData[questionId] = answerDrag;
            return newDragData;
        });
    };


    const handleRadioChange = (questionId: number, answerId: number) => {
        setSelectedAnswers((prevSelectedAnswers) => {
            return {
                ...prevSelectedAnswers,
                [questionId]: answerId,
            };
        });
    };


    const mapSelectedAnswers = (selectedAnswers: { [key: number]: number }): Answer[] => {
        return Object.entries(selectedAnswers).map(([questionId, answerId]) => ({
            questionId: parseInt(questionId, 10),
            answerId: answerId as number,
        }));
    };

    const mapDragData = (dragData: { [key: number]: { id: number; position: number ; text: string}[] }): DragData[] => {
        return Object.entries(dragData).map(([questionId, answerDrag]) => ({
            questionId: parseInt(questionId, 10),
            answerDrag: answerDrag as { id: number; position: number; text: string }[],
        }));
    };


    const handleSubmit = () => {
        const allSubmissionData = mapSelectedAnswers(selectedAnswers);
        const dragDataArray = mapDragData(dragData);

        const submissionDataWithTestId = {
            testId: model.id,
            answers: allSubmissionData,
            drag: dragDataArray.reduce((acc, curr) => {
                acc[curr.questionId] = curr.answerDrag.map(item => ({id: item.id, position: item.position, text: item.text}));
                return acc;
            }, {} as { [key: number]: { id: number; position: number ; text: string}[] }),
        };

        dispatch(resetCorrectTestCount());
        dispatch(resetTestViewAnswerId());

        dispatch(postStudentAnswer({testId: model.id, requestData: submissionDataWithTestId}))
            .then(() => {
                if (testId && userId) {
                    navigate(`/test/${testData.model.id}/view-answer/${userId}`);
                }
            })
            .catch((error) => {
                console.error('Error submitting student answer:', error);
            });
    };

    return (
        <div className="tabs-content">
            <div className="tab">

                {isStatusTestVisible && <StatusTest/>}

                {isLoading ? (
                    <Preloader/>
                ) : model?.testItems?.length > 0 ? (
                    <div className="test-descr-box">
                        {model?.testItems?.map((question: any, index: number) =>
                            question.tabType === 'textType' && question.questionType !== 'determineProcedure' ? (
                                <div className="test-descr-item" key={question.id}>
                                    <p className="h4 test-descr-title">
                                        <span className="index-num">{++index}</span>
                                        {question.before || question.after || question.afterSecond ? (
                                            <>
                                                {question.before}
                                                <span className="dots">...</span>
                                                {question.after}
                                                {question.afterSecond ? (
                                                    <>
                                                        <span className="dots">...</span>
                                                        {question.afterSecond}
                                                    </>
                                                ) : null}
                                            </>
                                        ) : (
                                            question.questionTitle
                                        )}
                                    </p>
                                    <div className="radio-group in-cols">
                                        {question.answers.map((answer: any) => (
                                            <div className="col" key={answer.id}>
                                                <div className="radio-item">
                                                    <input
                                                        id={`answer-option-inp${question.id}-${answer.id}`}
                                                        name={`radioGroup-${question.id}`}
                                                        type="radio"
                                                        onChange={() => handleRadioChange(question.id, answer.id)}
                                                    />
                                                    <label htmlFor={`answer-option-inp${question.id}-${answer.id}`}>
                                                        {answer.text}
                                                    </label>
                                                </div>
                                            </div>
                                        ))}
                                    </div>
                                </div>
                            ) : question.tabType === 'audioType' && question.questionType !== 'determineProcedure' ? (
                                <div className="test-descr-item" key={question.id}>
                                    <p className="h4 test-descr-title">
                                        <span className="index-num">{++index}</span>
                                        {question.questionTitle}
                                    </p>
                                    <TestAudio audioUrl={question.file.path}/>
                                    <div className="radio-group in-cols">
                                        {question.answers.map((answer: any) => (
                                            <div className="col" key={answer.id}>
                                                <div className="radio-item">
                                                    <input
                                                        id={`answer-option-inp${question.id}-${answer.id}`}
                                                        name={`radioGroup-${question.id}`}
                                                        type="radio"
                                                        onChange={() => handleRadioChange(question.id, answer.id)}
                                                    />
                                                    <label htmlFor={`answer-option-inp${question.id}-${answer.id}`}>
                                                        {answer.text}
                                                    </label>
                                                </div>
                                            </div>
                                        ))}
                                    </div>
                                </div>
                            ) : question.tabType === 'imageType' && question.questionType !== 'determineProcedure' ? (
                                <div className="test-descr-item" key={question.id}>
                                    <p className="h4 test-descr-title">
                                        <span className="index-num">{++index}</span>
                                        {question.questionTitle}
                                    </p>
                                    <TestImage imageUrl={question.file?.path}/>
                                    <div className="radio-group in-cols">
                                        {question.answers.map((answer: any) => (
                                            <div className="col" key={answer.id}>
                                                <div className="radio-item">
                                                    <input
                                                        id={`answer-option-inp${question.id}-${answer.id}`}
                                                        name={`radioGroup-${question.id}`}
                                                        type="radio"
                                                        onChange={() => handleRadioChange(question.id, answer.id)}
                                                    />
                                                    <label htmlFor={`answer-option-inp${question.id}-${answer.id}`}>
                                                        {answer.text}
                                                    </label>
                                                </div>
                                            </div>
                                        ))}
                                    </div>
                                </div>
                            ) : question.tabType === 'textType' && question.questionType === 'determineProcedure' ? (
                                <div className="test-descr-item" key={question.id}>
                                    <p className="h4 test-descr-title">
                                        <span className="index-num">{++index}</span>
                                        {question.questionTitle}
                                    </p>
                                    <TestDrag key={model.id} answers={question.answers} questionId={question.id}
                                              onDragChange={handleDragChange}/>
                                </div>
                            ) : question.tabType === 'audioType' && question.questionType === 'determineProcedure' ? (
                                    <div className="test-descr-item" key={question.id}>
                                        <p className="h4 test-descr-title">
                                            <span className="index-num">{++index}</span>
                                            {question.questionTitle}
                                        </p>
                                        <TestAudio audioUrl={question.file.path}/>
                                        <TestDrag key={question.id} answers={question.answers} questionId={question.id}
                                                  onDragChange={handleDragChange}/>
                                    </div>)
                                : question.tabType === 'imageType' && question.questionType === 'determineProcedure' ? (
                                    <div className="test-descr-item" key={question.id}>
                                        <p className="h4 test-descr-title">
                                            <span className="index-num">{++index}</span>
                                            {question.questionTitle}
                                        </p>
                                        <TestImage imageUrl={question.file?.path}/>
                                        <TestDrag key={question.id} answers={question.answers} questionId={question.id}
                                                  onDragChange={handleDragChange}/>
                                    </div>)
                                : null
                        )}

                        <div className="btns-box aside-btns">
                            <div className="col btns-col col_btns">
                                <p
                                    className="btn"
                                    onClick={handleSubmit}
                                >
                                    <span>Отправить ответ</span>
                                </p>

                            </div>
                        </div>
                    </div>
                ) : (
                    <NothingYetMessage/>
                )}
            </div>
        </div>
    );
};

